  $(document).ready(function(){
    $(document).on('click', '.wrap_column_mian .main_heading_width', function(){
      $(this).parents('.wrap_column_mian').find('.head_content p').slideToggle("ease-out");
        $(this).toggleClass('is-active');
  
});
    });

$(document).ready(function(){
  $(document).on('click',".information-accordion .information-content .information-head", function () {
    $(".open").not(this).removeClass("open").next().slideUp();
    $(this).toggleClass("open").next().slideToggle();
  });
});

$(document).on('click', '.side_filtermain .filter_heading', function(e) {

  var tab_id = $(this).attr('data-tab');
  
  $(this).toggleClass('active');
  $("#"+tab_id).toggleClass('Inactive'); 
});




